<template>
  <div style="padding-top: 24px">
    <!-- <loading :active.sync="loadingDataInit"></loading> -->
    <!-- <LoadingCenter v-if="loadingDataInit || loadingInit" /> -->

    <HeaderEmpresa></HeaderEmpresa>
    <!-- <NavigationInbox
      :style="navHome ? '' : 'display:none'"
      :links="links"
    ></NavigationInbox> -->
    <v-main>
    
      <router-view />
    </v-main>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import LoadingCenter from "@/util/LoadingCenter.vue";

import { mapActions, mapGetters, mapState } from "vuex";
import HeaderEmpresa from "@/layouts/app/inbox/header/HeaderEmpresa.vue";
import NavigationInbox from "@/layouts/app/inbox/navigation/NavigationInbox.vue";

export default {
  name: "AdminLayout",
  components: {
    HeaderEmpresa,
    NavigationInbox,
    Loading,
    LoadingCenter,
  },
  data() {
    return {
      hidenNav: false,

      links: [],
      menuName: "administrador",
    };
  },
  computed: {
    ...mapState(["loading"]),

    ...mapState("initialData", ["loadingDataInit"]),
    ...mapState(["loadingInit"]),
    ...mapGetters("notificaciones", ["bloqueoRetiroDinero"]),
    ...mapState("notificaciones", ["alerta_retiro"]),

    navHome() {
      if ("navHome" in this.$route.meta) {
        return this.$route.meta.navHome;
      } else {
        return true;
      }
    },
    ...mapGetters(["getLinksDelMenu"]),
  },
  methods: {
    msotrar() {
      this.$store.dispatch("alerts/showSnackbar", {
        text: "¿Deseás continuar?",
        color: "warning",
        icon: "mdi-alert",
        timeout: -1,
        button: true,
        textButton: "Continuar",
        action: () => {
          this.$router.push("/otro-lugar");
        },
      });
    },
    ...mapActions(["fetchLinksPorMenu"]),
    async obtenerLinksDelMenu(menuName) {
      if (menuName) {
        console.log("layoubasic", menuName);
        await this.fetchLinksPorMenu(menuName); // Espera a que la acción termine antes de continuar
        this.links = this.getLinksDelMenu(menuName);
      }
    },
  },
  watch: {
    alerta_retiro(val) {
      if (val) {
        if (this.bloqueoRetiroDinero) {
          this.$router.push("/movimientos/retiro");
        }
        setTimeout(() => {
          this.$updateBus.$emit("showSnackBar", {
            show: true,
            color: "warning",
            button: true,
            top: false,
            right: false,
            left: true,
            textButton: "Retirar",
            text: `Hacer un retiro`,
            icon: "mdi-bell-ring",
            timeout: -1,
            action: () => {
              this.$router.push("/movimientos/retiro");
            },
          });
        }, 1500);
      }
    },
  },

  created() {
    this.obtenerLinksDelMenu(this.menuName);
  },
};
</script>

<style lang="scss" scoped>
</style>